module.exports = ".ssf-accordion__head {\n  cursor: pointer; }\n\n.ssf-accordion__head_template {\n  padding: 0 0.5rem 0 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end; }\n\n.ssf-accordion__body {\n  border-top: 0.05rem solid lightgrey; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/accordion/accordion.component.scss
// module id = 609
// module chunks = 3